import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '~spa/Components/Icon';

const Tab = ({ options, onTabSelected, dateInfo, gtmAttribute }) => {
    const {
        variant,
        label,
        onClick: onTabClick,
        icon: iconName,
        iconLabel,
        iconSize,
        fluid,
        counter,
        selected,
    } = options;

    const labelContent = dateInfo || label;

    const tabWrapperClassName = classNames('nav-tabs__tab', {
        [`nav-tabs__tab--${variant}`] : typeof variant === 'string',
    });

    const tabClassName = classNames('bb-menu-tabs__tab', `bb-menu-tabs__tab--${iconName}`, {
        ['bb-menu-tabs__tab--fluid'] : labelContent && fluid,
        ['bb-menu-tabs__tab--selected'] : selected,
        ['bb-menu-tabs__tab--max-width-75'] : !fluid,
    });

    return (
        <span
            className={tabWrapperClassName}
            onClick={onTabSelected}
            data-spectate-product={gtmAttribute}
        >
            <span
                className={tabClassName}
                onClick={onTabClick}
            >
                <Icon name={iconName} size={iconSize} content={iconLabel} />
                <TabLabelContent content={labelContent} />
                <TabCounter counter={counter} />
            </span>
        </span>
    );
};

const TabLabelContent = ({ content }) => {
    if (!content) {
        return null;
    }

    return (
        <div
            className='bb-menu-tabs__label'
        >
            {content}
        </div>
    );
};

const TabCounter = ({ counter }) => {
    if (!counter) {
        return null;
    }

    return (
        <div className='bb-counter-events' />
    );
};

Tab.propTypes = {
    options: PropTypes.shape({
        /** A Tab can have a label */
        label: PropTypes.string,

        /** A Tab can be selected */
        selected: PropTypes.bool.isRequired,

        /** A Tab can have an icon */
        icon: PropTypes.string,

        /** A Tab icon can have be a text */
        iconLabel: PropTypes.string,

        /** A Tab icon size can be defined */
        iconSize: PropTypes.string,

        /** Take the size of its container */
        fluid: PropTypes.bool,

        /** A Tab can have a counter */
        counter: PropTypes.string,

        /**
         * Style variant:
         *     - 'big-label': The label's text has a bigger size
         *     - 'vertical-icon': Icon and label are vertical aligned
         */
        variant: PropTypes.oneOf(['big-label', 'vertical-icon']),

        /** Callback called when the tab is clicked */
        onClick: PropTypes.func,
    }),

    /** Callback called when the tab is selected */
    onTabSelected: PropTypes.func,

    dateInfo: PropTypes.element,
    gtmAttribute: PropTypes.string,
};

TabCounter.propTypes = {
    counter: PropTypes.string,
};

TabLabelContent.propTypes = {
    content: PropTypes.string,
};

export default Tab;
